import { EmploymentSearchDto } from '@app/api2/api';
import * as Yup from 'yup';

export const EmploymentSearchSchema: Yup.SchemaOf<EmploymentSearchDto> = Yup.object({
    discriminator: Yup.string().required(),
    operator: Yup.string().optional(),
    occupation: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { employerName, employerCity } = this.parent;
            return !!value || !!employerName || !!employerCity;
        }
    ),
    employerName: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { occupation, employerCity } = this.parent;
            return !!value || !!occupation || !!employerCity;
        }
    ),
    employerCity: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { occupation, employerName } = this.parent;
            return !!value || !!occupation || !!employerName;
        }
    ),
});
